import '../../utils/index.mjs';
import Backtop from './src/backtop.mjs';
export { backtopEmits, backtopProps } from './src/backtop2.mjs';
import { withInstall } from '../../utils/vue/install.mjs';

const ElBacktop = withInstall(Backtop);

export { ElBacktop, ElBacktop as default };
//# sourceMappingURL=index.mjs.map
